import { render } from "./freightSelect.vue?vue&type=template&id=373d9bc0"
import script from "./freightSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./freightSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/freightSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "373d9bc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('373d9bc0', __exports__)) {
    api.reload('373d9bc0', __exports__)
  }
  
  module.hot.accept("./freightSelect.vue?vue&type=template&id=373d9bc0", () => {
    api.rerender('373d9bc0', render)
  })

}


export default __exports__